import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { ProblemProof } from './components/ProblemProof';
import { FunctionalSpiceGrid } from './components/FunctionalSpiceGrid';
import { UseCases } from './components/UseCases';
import { SubscriptionBox } from './components/SubscriptionBox';
import { FutureRoadmap } from './components/FutureRoadmap';
import { HowItWorks } from './components/HowItWorks';
import { StickyFooter } from './components/StickyFooter';
import { ScrollSpiceExplosions } from './components/ScrollSpiceExplosions';
import { FloatingSocialCapsule } from './components/FloatingSocialCapsule';
import { SocialFooter } from './components/SocialFooter';
export function App() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <LanguageProvider data-id="element-0">
      <div className="w-full min-h-screen bg-white relative" data-id="element-1">
        <Navigation onScrollToSection={scrollToSection} data-id="element-2" />
        <ScrollSpiceExplosions data-id="element-3" />
        <FloatingSocialCapsule data-id="element-4" />
        <div className="relative z-10" data-id="element-5">
          <div id="hero" data-id="element-6">
            <Hero onScrollToSection={scrollToSection} data-id="element-7" />
          </div>
          <div id="spices" data-id="element-8">
            <FunctionalSpiceGrid data-id="element-9" />
          </div>
          <div id="use-cases" data-id="element-10">
            <UseCases data-id="element-11" />
          </div>
          <div id="subscription" data-id="element-12">
            <SubscriptionBox data-id="element-13" />
          </div>
          <div id="how-it-works" data-id="element-14">
            <HowItWorks data-id="element-15" />
          </div>
          <div id="problem-proof" data-id="element-16">
            <ProblemProof onScrollToSection={scrollToSection} data-id="element-17" />
          </div>
          <div id="roadmap" data-id="element-18">
            <FutureRoadmap data-id="element-19" />
          </div>
          <SocialFooter data-id="element-20" />
          <StickyFooter onScrollToSection={scrollToSection} data-id="element-21" />
        </div>
      </div>
    </LanguageProvider>;
}